import { createSlice } from "@reduxjs/toolkit";

const initialState = { modal: null, tab: null, data: null };

// eslint-disable-next-line import/prefer-default-export
export const modalsSlice = createSlice({
  name: "modals",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setCurrentModal: (state, action) => {
      state.modal = action.payload.modal;
      state.tab = action.payload.tab;
      state.data = action.payload.data;
    },
    setModalTab: (state, action) => {
      state.tab = action.payload;
    },
    setModalData: (state, action) => {
      state.data = action.payload;
    },
    closeModal: () => initialState,
  },
});

export const { setCurrentModal, setModalTab, setModalData, closeModal } =
  modalsSlice.actions;

export default modalsSlice.reducer;

export const selectCurrentModal = (state) => state.modals.modal;
export const selectModalTab = (state) => state.modals.tab;
export const selectModalData = (state) => state.modals.data;
